import { Component, Input, OnInit, ViewEncapsulation, PLATFORM_ID, Inject, ElementRef, OnDestroy, Injector } from '@angular/core';
import { TagTextData } from '../tag-text/tag-text.component';
import { UpaTarget } from '../../services/upa.service';
import { isPlatformBrowser } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { HotelsBoxService } from 'projects/common/services/hotelsBox.service';
import { Subscription } from 'rxjs';
import { AbstractComponent } from '../abstract.component';
import { ScreenType } from '../../model/ScreenType';
import { UtilsService } from 'projects/common/services/utils.service';

declare var window: any;

export type SboxModule = {
  box: string;
  filtered: boolean;
  code: string;
  init: object;
  ubication: string;
  expanded: boolean;
  hide_advanced_options: boolean;
  hide_without_date: boolean;
  hide_bundles: boolean;
  hide_vr_filter: boolean;
  small?: boolean;
  datepicker_open_by_default?: boolean;
  features?: string[];
  extra_search_query_params?: Map<string, string>;
};

export interface SearchboxInitializationTrackingData {
  xClient: string;
  context: string;
  tcli: string;
  cc: string;
  ch: string;
  pr: string;
  pageview_id: string;
  userid: string;
  company_id: string;
}

export interface SearchboxInitializationConfigInnerObject {
  language: string;
}

export interface SearchboxInitializationConfiguration {
  trackingData: SearchboxInitializationTrackingData;
  useLocalStorage: boolean;
  abstring: string;
  config: SearchboxInitializationConfigInnerObject;
  profileSuggester: string;
  destination?: Object | Object[];
  origin?: Object | Object[];
  selectedMonths?: string;
  outboundMonthRanges?: string[];
  type: "sbox" | "sbox-bar";
  airlineCode?: string;
  adults?: number;
  display?: string;
  target?: Object;
  dates?: string[];
  endDate?: string;
}

export interface SearchBoxModel {
  start_date_description: string,
  end_date_description: string,
  adults: number,
  destination_description: string;
}

@Component({
  selector: 'sbox',
  template: `
    <div [ngStyle]="{'display': hideSbox ? 'none' : ''}" [ngClass]="{'small-container': sboxModule.small ?? false}">
      <main-title *ngIf="title" [data]="{ title: title, sub_title: subtitle }"
                  titleColor="var(--color-neutral-800)" class="-eva-3-mb-xxlg" [moduleId]="moduleId"
                  [uniqueId]="uniqueId"></main-title>
      <div id="searchboxv2-wrapper" *ngIf="sboxType === 'sbox'; else sboxElse"
           [ngClass]="{'sbox_hide_bundles': sboxModule.hide_bundles, 'sbox_hide_advanced_options': sboxModule.hide_advanced_options, 'sbox_hide_without_date': sboxModule.hide_without_date, 'sbox_hide_vr_filter': sboxModule.hide_vr_filter }">
        <div *ngIf="showSnippet; else elseBlock">
          <div [innerHTML]="htmlSnippet"></div>
        </div>
        <ng-template #elseBlock>
          <searchbox-v2
            [product]="this.sboxProduct"
            [flow]="this.flow"
            [showClose]="false"
            [hideBundles]="sboxModule.hide_bundles"
            [hideAdvancedOptions]="sboxModule.hide_advanced_options"
            [hideWithoutDate]="sboxModule.hide_without_date"
            [hideVrFilter]="sboxModule.hide_vr_filter"
            [searchboxModel]="this.initConfig"
            (onSearch)="trackSearch()"
            [locale]="locale"
            [modeAjax]="modeAjaxEnabled"
            [extraQueryParams]="getExtraQueryParams()">
          </searchbox-v2>
        </ng-template>
      </div>
      <ng-template #sboxElse>
        <searchbox-bar-v2
          [locale]="locale"
          [flow]="flow"
          [product]="this.sboxProduct"
          [searchboxModel]="this.initConfig"
          [webviewUrl]="webviewUrl!"
          [channelType]="whiteLabel ? 'WHITE_LABEL': 'SITE'"
          [showClose]="true"
          [hideBundles]="sboxModule.hide_bundles"
          [hideAdvancedOptions]="sboxModule.hide_advanced_options"
          [hideWithoutDate]="sboxModule.hide_without_date"
          [hideVrFilter]="sboxModule.hide_vr_filter"
          (onSearch)="trackSearch()"
          [modeAjax]="modeAjaxEnabled"
          [extraQueryParams]="getExtraQueryParams()">
          <li class="re-search-item">
              <span class="item-container">
                <i class="eva-3-icon-location re-search-item-icon"></i>
                <span *ngIf="hasDestinationDescription()" class="item-content">
                    {{ searchBoxModel.destination_description }}
                </span>
                <span *ngIf="!hasDestinationDescription()" class="item-content">
                    {{ "sbox.selectDestination" | translate }}
                </span>
              </span>
          </li>
          <li class="re-search-item">
              <span class="item-container">
                <i class="eva-3-icon-calendar re-search-item-icon"></i>
                {{ "sbox.chooseADate" | translate }}
                <span class="item-content item-date">
                    <span class="item-date-container">
                        {{ searchBoxModel.start_date_description }}
                    </span>
                    <span class="-eva-3-hide-small" *ngIf="searchBoxModel.end_date_description"> - </span>
                    <span class="item-date-container">
                        {{ searchBoxModel.end_date_description }}
                    </span>
                </span>
              </span>
          </li>
          <li class="re-search-item">
              <span class="item-container">
                <i class="eva-3-icon-user re-search-item-icon"></i>
                <span class="item-content">
                    {{ searchBoxModel.adults }}
                </span>
              </span>
          </li>
        </searchbox-bar-v2>
      </ng-template>
    </div>
  `,
  styleUrls: ['./sbox.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SboxComponent extends AbstractComponent implements OnInit, OnDestroy {
  public static MODULE_ID: string = 'SBoxModule';
  public static FINISH_MOUNT_EVENT: string = "finishSboxMount";
  @Input() sboxModule: SboxModule;
  @Input() title?: TagTextData;
  @Input() subtitle?: TagTextData;
  @Input() modulePosition: number;
  @Input() uniqueId?: string;
  @Input() moduleId;
  @Input() forceSearchboxBar: boolean;
  @Input() nextToShifu: boolean = false;

  searchBoxModel: SearchBoxModel;
  sboxType: "sbox" | "sbox-bar";
  locale: string;
  webview: boolean;
  searchBoxDependecy: any;
  webviewUrl?: string;
  override flow = 'landing';
  sboxProduct: string;
  whiteLabel: boolean;
  showSnippet: boolean = false;
  htmlSnippet: SafeHtml;
  initConfig: SearchboxInitializationConfiguration;
  locationName: string;
  box: any;
  boxPosition: number;

  hideSbox: boolean;
  modeAjaxEnabled = false;

  hotelsBoxSubscription?: Subscription;

  constructor(injector: Injector,
    @Inject(PLATFORM_ID) private platformId: any,
    private domSanitizer: DomSanitizer,
    private hotelsBoxService: HotelsBoxService,
    private elementRef: ElementRef
  ) {
    super(injector);
    if (isPlatformBrowser(this.platformId)) {
      if (window.hotelsBox) {
        this.box = window.hotelsBox.Factory();
      } else if (window.vacationrentalsBox) {
        this.box = window.vacationrentalsBox.Factory();
      }
    }
  }

  ngOnInit(): void {
    const landingModel = this.landingModelService.getLandingModel();
    this.sboxModule ||= { init: {}, hide_advanced_options: false, hide_bundles: false, hide_without_date: false, hide_vr_filter: false } as SboxModule;
    this.hideSbox = landingModel.abTests?.tests?.shifuReducedSboxV2?.enabled == "true";

    this.htmlSnippet = this.domSanitizer.bypassSecurityTrustHtml(landingModel.dependencies?.sbox?.snippet);
    this.sboxProduct = landingModel.dependencies.sbox?.product;
    this.webview = landingModel.webview;
    this.whiteLabel = landingModel.whiteLabel;
    this.searchBoxDependecy = landingModel.dependencies.sbox;
    this.locale = landingModel.language + '-' + landingModel.country;
    this.screenType = landingModel.device.type;
    this.sboxType = (!this.forceSearchboxBar && (this.screenType == ScreenType.DESKTOP || this.sboxModule.expanded)) ? "sbox" : "sbox-bar";
    this.searchBoxModel = this.initSearchBoxModel();

    if (this.webview && !landingModel.showSboxInWebview) {
      this.webviewUrl = 'https://sbox.despegar.com/?productType=' + this.searchBoxDependecy.product + '&distribution=2';
    }

    const defaultSSR = 'NO_HUMAN_USER'
    let userid = defaultSSR,
      pageview_id = defaultSSR,
      company_id = defaultSSR,
      channel = defaultSSR,
      selectedMonths,
      outboundMonthRanges,
      dates,
      endDate;

    // Si es un usuario real, populo los campos de trackeo.
    if (isPlatformBrowser(this.platformId)) {
      const upaData = window.upaData;
      if (upaData) {
        userid = upaData.userid;
        pageview_id = upaData.pageview_id;
        company_id = upaData.company_id;
        channel = upaData.ch;
      }
      const searchParams = new URLSearchParams(globalThis.location.search);
      selectedMonths = searchParams.get('departure_months');
      outboundMonthRanges = searchParams.get("outboundMonthRanges")?.split(",");
      dates = searchParams.get("fromDate") ? [ searchParams.get('fromDate') ] : undefined;
      endDate = searchParams.get("toDate");
    } else {
      this.showSnippet = true;
    }

    // todo: arreglar para hacer pasamanos de sbox.init y no agregar las props manualmente
    this.initConfig = {
      trackingData: {
        xClient: 'nymeria',
        context: landingModel.flow,
        tcli: 'frontend-components',
        cc: landingModel.country,
        ch: channel,
        pr: this.sboxModule.box ?? '',
        userid,
        pageview_id,
        company_id
      },
      useLocalStorage: !this.sboxModule.init?.['destination'],
      abstring: landingModel.abTests && landingModel.abTests.ab ? landingModel.abTests.ab : '',
      config: {
        language: landingModel.language
      },
      profileSuggester: this.sboxModule.init?.['profile_suggester'],
      airlineCode: this.sboxModule.init?.['airline_code'],
      origin: UtilsService.keysToCamel(this.sboxModule.init?.['origin']),
      destination: UtilsService.keysToCamel(this.sboxModule.init?.['destination']),
      type: this.sboxType,
      selectedMonths,
      outboundMonthRanges,
      dates,
      endDate,
    };

    if (this.sboxModule.init?.['adults']) {
      this.initConfig.adults = this.sboxModule.init?.['adults'];
    }
    if (this.sboxModule.init?.['display']) {
      this.initConfig.display = this.sboxModule.init?.['display'];
    }
    if (this.sboxModule.init?.['target']) {
      this.initConfig.target = this.sboxModule.init?.['target'];
    }

    this.modeAjaxEnabled = landingModel.flow == 'home';

    if (this.sboxProduct == 'hotels' || this.sboxProduct == 'vacationrentals') {
      this.initAccommodationsSbox();
    } else if (this.sboxModule.init?.['destination_explorer']) {
      this.initExploradorDestinosSbox();
    }
  }

  ngOnDestroy(): void {
    if (this.hotelsBoxSubscription) {
      this.hotelsBoxSubscription.unsubscribe();
    }
    if (isPlatformBrowser(this.platformId)) {
      document.removeEventListener(SboxComponent.FINISH_MOUNT_EVENT, this.scrollToSbox);
      document.removeEventListener(SboxComponent.FINISH_MOUNT_EVENT, this.updateSboxProps);
    }
  }

  initSearchBoxModel(): SearchBoxModel {
    // @ts-ignore
    let { start_date_description, end_date_description, adults, destination, destination_description } = this.sboxModule?.init ?? {};
    if (this.sboxModule?.init) {
      if (destination?.display) {
        destination_description = destination.display;
      } else if (destination && destination instanceof Array && destination.length) {
        destination_description = destination[0].display;
      }
    }
    return {
      adults: adults || 2,
      start_date_description,
      end_date_description,
      destination_description
    };
  }

  hasDestinationDescription(): boolean {
    return !!this.searchBoxModel.destination_description;
  }

  trackSearch() {
    this.upaService.trackClickTopic({
      label: 'Searchbox',
      moduleId: this.moduleId,
      moduleIndex: this.modulePosition,
      target: UpaTarget.SEARCHBOX,
      uniqueId: this.uniqueId
    });
  }

  getExtraQueryParams(): Map<string, string> {
    const extraQueryParams = this.sboxModule.extra_search_query_params;
    return extraQueryParams ? new Map<string, string>(Object.entries(extraQueryParams)) : new Map<string, string>();
  }

  getModuleId() {
    return SboxComponent.MODULE_ID;
  }
  
  private initAccommodationsSbox() {
    if (isPlatformBrowser(this.platformId)) {
      document.addEventListener(SboxComponent.FINISH_MOUNT_EVENT, this.scrollToSbox);
    }

    this.hotelsBoxSubscription = this.hotelsBoxService.hotelSelected.subscribe(data => {
      this.sboxModule.init ||= {};
      if (!this.sboxModule.init?.['destination']) {
        this.sboxModule.init['destination'] = {};
      }
      if (!this.sboxModule.init?.['destination']?.['target']) {
        this.sboxModule.init['destination']['target'] = {};
      }

      let display;
      if (this.sboxModule.init?.['destination_type'] == 'HOTEL') {
        display = this.locationName = this.sboxModule.init?.['destination_description'];
      } else {
        display = data.name;
      }

      this.sboxModule.init['hotel_oid'] = data.id;
      this.sboxModule.init['destination']['id'] = data.gid;
      this.sboxModule.init['destination']['display'] = display;
      this.sboxModule.init['destination']['target']['id'] = data.id;
      this.sboxModule.init['destination']['target']['gid'] = data.gid;
      this.sboxModule.init['destination']['target']['type'] = "HOTEL";

      const hotelData = {
        type: "forceBox", payload: {
          id: data.gid,
          target: {
            id: data.id,
            gid: data.gid,
            type: "HOTEL",
            parents: {
              city: data.city
            }
          },
          display: display
        }
      };
      if (isPlatformBrowser(this.platformId)) {
        if (this.screenType == ScreenType.DESKTOP) {
          window.scrollTo({ top: this.boxPosition, behavior: 'smooth' });
        }
        this.box.dispatch(hotelData);
      }
    });
  }

  private scrollToSbox = () => {
    if (this.sboxModule.datepicker_open_by_default && this.screenType == ScreenType.DESKTOP) {
      // Se abre el datepicker al cargar la caja
      this.box.dispatch({ type: 'forceBox' });
    }
    this.boxPosition = this.elementRef.nativeElement.getBoundingClientRect().top + window.scrollY;
  }

  private initExploradorDestinosSbox() {
    this.initConfig = { ...this.initConfig, ...this.sboxModule.init };
    this.initConfig && (this.initConfig.origin = UtilsService.keysToCamel(this.initConfig.origin));
    this.initConfig && (this.initConfig.destination = UtilsService.keysToCamel(this.initConfig.destination));

    if (isPlatformBrowser(this.platformId) && !window.searchbox?.sboxLoaded) {
      document.addEventListener(SboxComponent.FINISH_MOUNT_EVENT, this.updateSboxProps);
    }
  }

  private updateSboxProps = () => {
    window.searchbox.updateProps(this.initConfig);
  }
}